import { render, staticRenderFns } from "./a2p-brand-bundle-table.vue?vue&type=template&id=01e8e97a"
import script from "./a2p-brand-bundle-table.vue?vue&type=script&lang=js"
export * from "./a2p-brand-bundle-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports